export interface IStore {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: Store;
  distance: number;
  isOpen: boolean;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
  orderTypes: OrderType[];
}

interface Industry {
  id: number;
  arabicName: string;
  englishName: string;
}

export interface IStoresIndustryGroup {
  groupArabicName: string;
  groupEnglishName: string;
  industries: Industry[];
}

export enum OrderType {
  Now = 1,
  Scheduled = 2,
  Gift = 3,
  Pickup = 4, // not used
  Global = 5,
}

type TIndustries = {
  id: number;
  arabicName: string;
  englishName: string;
}[];
export interface Store {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  logoURL: string;
  logoUrl: string;
  arabicDescription: string;
  englishDescription: string;
  industries: TIndustries;
}

export interface IBranch {
  BranchDetails: IBranchDetails;
  BranchIndustries: BranchIndustries[];
  IsFavoriteBranch: boolean;
}

export interface BranchIndustries {
  id: number;
  arabicName: string;
  englishName: string;
  subIndustries: SubIndustry[] | null;
}

export interface SubIndustry {
  id: number;
  arabicName: string;
  englishName: string;
  subIndustries: SubIndustry[] | null;
}

export interface IBranchScheduleDays {
  day: number;
  dayString: string;
  arabicDayString: string;
  englishDayString: string;
  branchScheduleOpeningHours: {
    startHour: string;
    endHour: string;
  }[];
  isClosed: boolean;
}

export interface ISchedules {
  branchScheduleDays: IBranchScheduleDays[];
  scheduleType: number;
  scheduleTypeString: string;
  arabicScheduleTypeString: string;
  englishScheduleTypeString: string;
}

export interface IOrderTypes {
  type: number;
  typeString: string;
  arabicTypeString: string;
  englishTypeString: string;
}

export interface IBranchDetails {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  store: Store;
  orderTypes: IOrderTypes[];
  schedules: ISchedules[];
  availableBranches: AvailableBranches[];
  distance: number;
  deliveryFee: number;
  isOpen: boolean;
  isExpress: boolean;
  acceptsBuyNowPayLater: boolean;
}

export interface AvailableBranches {
  id: number;
  name: string;
  arabicName: string;
  englishName: string;
  distance: number;
  isOpen: boolean;
  isSelected: boolean;
}
